export const home_and_sideBar_events = {
  home_preferences_click: {
    category: "User opening preferences dialog",
    action: "User clicks on preferences button ",
    label: "sidebar-preferences-click",
  },
  home_side_bar_close_click: {
    category: "User closes to side menu",
    action: "User clicks on close icon",
    label: "sidebar-close",
  },
  home_side_bar_open_click: {
    category: "home-load",
    action: "User clicks on hamburger icon",
    label: "sidebar-open",
  },
  Terms_of_service_click: {
    category: "User clicks on terms of service link",
    action: "User clicks on Terms of Service in sidebar",
    label: "sidebar-tos-click",
  },
  Privacy_polcy_click: {
    category: "User navigates to the privacy policy",
    action: "User clicks on privacy policy button",
    label: "sidebar-privacy-policy-click",
  },
  sidebar_get_help: {
    category: "Sidebar interaction",
    action: "User clicks on Get Help in sidebar",
    label: "sidebar-get-help",
  },
  get_help_input_name: {
    category: "Get Help",
    action: "User enters name in help form",
    label: "support-modal-name-input",
  },
  get_help_input_email: {
    category: "Get Help",
    action: "User enters email in help form",
    label: "support-modal-email-input",
  },
  get_help_input_phone: {
    category: "Get Help",
    action: "User enters phone number in help form",
    label: "support-modal-phone-input",
  },
  get_help_issue_type: {
    category: "Get Help",
    action: "User selects issue type",
    label: "support-modal-issue-type-click",
  },
  get_help_input_message: {
    category: "Get Help",
    action: "User types a message",
    label: "support-modal-message-input",
  },
  get_help_close: {
    category: "Get Help",
    action: "User closes the help form",
    label: "support-modal-close-click",
  },
  get_help_send: {
    category: "Get Help",
    action: "User submits the help form",
    label: "support-modal-send-click",
  },

  sidebar_contact_us: {
    category: "Sidebar interaction",
    action: "User clicks on Contact Us in sidebar",
    label: "sidebar-support-click",
  },
  sidebar_chat_with_us: {
    category: "Sidebar interaction",
    action: "User clicks on Chat With Us in sidebar",
    label: "sidebar-chat-with-us",
  },
  Login_in_click: {
    category: "User clicks on login button to open the popup",
    action: "User clicks on Login button",
    label: "menu-login-click",
  },
  Signup_in_click: {
    category: "User clicks on signup button to open the popup",
    action: "User clicks on Signup button",
    label: "menu-sign-up-click",
  },
  signup_switch_click: {
    category: "Signup",
    action: "User switches to signup modal",
    label: "signup-switch-click",
  },
  login_switch_click: {
    category: "Login",
    action: "User switches to login modal",
    label: "login-switch-click",
  },
  signup_close: {
    category: "Signup",
    action: "User closes signup modal",
    label: "signup-close",
  },
  google_signup_click: {
    category: "Signup",
    action: "User clicks Google signup",
    label: "sign-up-with-google-click",
  },
  apple_signup_click: {
    category: "Signup",
    action: "User clicks Apple signup",
    label: "sign-up-with-apple-click",
  },
  facebook_signup_click: {
    category: "Signup",
    action: "User clicks Facebook signup",
    label: "sign-up-with-facebook-click",
  },
  signup_with_email_click: {
    category: "Signup",
    action: "User clicks Signup with Email",
    label: "sign-up-with-email-click",
  },
  signup_with_email_submit_click: {
    category: "Signup",
    action: "User clicks on signup with email submit button",
    label: "sign-up-with-email-submit-click",
  },
  signup_with_email_back_click: {
    category: "Signup",
    action: "User clicks back in signup with email modal",
    label: "sign-up-with-email-back-click",
  },
  signup_with_email_close_click: {
    category: "Signup",
    action: "User closes signup with email modal",
    label: "sign-up-with-email-close-click",
  },
  signup_with_email_input_email: {
    category: "Signup",
    action: "User enters email for signup",
    label: "sign-up-with-email-email-input-click",
  },
  signup_with_email_input_password: {
    category: "Signup",
    action: "User enters password for signup",
    label: "sign-up-with-email-password-input-click",
  },

  Logout: {
    category: "User logs out",
    action: "User clicks on logout button",
    label: "sidebar-log-out-click",
  },

  login_with_email_click: {
    category: "Login",
    action: "User clicks login with email",
    label: "log-in-with-email-click",
  },
  login_with_email_input_email: {
    category: "Login",
    action: "User enters email in login with email",
    label: "log-in-with-email-email-input-click",
  },
  login_with_email_input_password: {
    category: "Login",
    action: "User enters password in login with email",
    label: "log-in-with-email-password-input-click",
  },
  login_close: {
    category: "Login",
    action: "User closes login modal",
    label: "log-in-close-click",
  },
  login_signup_cta_click: {
    category: "Login",
    action: "User clicks back in sing up in login modal",
    label: "log-in-sign-up-cta-click",
  },
  login_with_email_back_click: {
    category: "Login",
    action: "User clicks back in login with email modal",
    label: "log-in-with-email-back-click",
  },
  reset_password_back_click: {
    category: "Login",
    action: "User clicks back in reset password modal",
    label: "reset-password-back-click",
  },
  login_reset_password_back_click: {
    category: "Login",
    action: "User clicks back in login with reset password modal",
    label: "log-in-reset-password-back-click",
  },
  login_with_email_close_click: {
    category: "Login",
    action: "User closes login with email modal",
    label: "log-in-with-email-close-click",
  },
  signup_with_email_input_name: {
    category: "Signup",
    action: "User enters name in signup with email sign-up",
    label: "sign-up-with-email-name-input-click",
  },
  login_with_email_sign_up_click: {
    category: "Login",
    action: "User clicks sign up in login with email",
    label: "login-with-email-sign-up-click",
  },
  login_back_click: {
    category: "Login",
    action: "User clicks back in login modal",
    label: "login-back-click",
  },

  My_trips_click: {
    category: "User clicks on my trips from the side bar to open the my trips",
    action: "User clicks on my trips link from the side bar",
    label: "sidebar-my-trips-click",
  },
  saved_trips_click: {
    category: "User clicks on saved trips from the side bar to open the saved trips",
    action: "User clicks on my saved trips link from the side bar",
    label: "sidebar-saved-trips-click",
  },
  Current_trips_click: {
    category: "User clicks to current trip to open the current trip",
    action: "User clicks on curretn trips link from the side bar",
    label: "menu-currenttrip-click",
  },
  History_click: {
    category: "User clicks from history list to open this trip",
    action: "User clicks on any one of the links from the history section from the sidebar",
    label: "sidebar-history-click",
  },
  History_delete_click: {
    category: "User clicks on delete button to delete this trip from the history",
    action: "User clicks on delete button on any one of the links from the history section in the sidebar",
    label: "history-delete-item-click",
  },
  new_trip_click: {
    category: "User want to start a new trip",
    action: "User clicks  on new trip",
    label: "sidebar-start-new-chat-click",
  },
  new_trip_public_click: {
    category: "User want to start a new trip",
    action: "User clicks  on new trip",
    label: "sidebar-start-public-chat-click",
  },
  sidebar_profile_click: {
    category: "Sidebar",
    action: "User clicks on profile from sidebar",
    label: "sidebar-profile-click",
  },

  book_without_itinerary_click: {
    category: "User want book a trip without itinerary",
    action: "User clicks book trip",
    label: "home-chat-book-without-itinerary-click",
  },
};
